import { useState } from 'react';

const testimonials = [
  {
    quote:
      'This pandabuy sheet system completely changed how I compare product prices and shipping quality. The structured spreadsheet approach saves me hours every week.',
    name: 'Marcus Thompson',
    role: 'Verified Shopper',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20man%20with%20short%20curly%20hair%20and%20warm%20smile%20wearing%20navy%20blazer%20over%20white%20t-shirt%2C%20soft%20natural%20window%20light%20from%20left%20side%2C%20blurred%20bookshelf%20background%20with%20warm%20tones%2C%20modern%20corporate%20portrait%20style&width=120&height=120&seq=avatar-marcus-v3&orientation=squarish',
  },
  {
    quote:
      'I have been using pandabuy spreadsheet for months now and the daily updates make it incredibly easy to find the best deals across all categories.',
    name: 'Elena Rodriguez',
    role: 'Power User',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20woman%20with%20long%20wavy%20dark%20hair%20and%20confident%20expression%20wearing%20cream%20knit%20sweater%2C%20soft%20studio%20lighting%20with%20warm%20peach%20backdrop%2C%20shallow%20depth%20of%20field%20with%20bokeh%20highlights%2C%20contemporary%20creative%20portrait%20style&width=120&height=120&seq=avatar-elena-v3&orientation=squarish',
  },
  {
    quote:
      'The smart scoring system in the pandabuy sheet is a game changer. No more guessing which product offers the best value for money.',
    name: 'James Chen',
    role: 'Early Adopter',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20asian%20man%20with%20glasses%20and%20stubble%20wearing%20charcoal%20henley%20shirt%2C%20dramatic%20side%20lighting%20creating%20defined%20shadows%20on%20face%2C%20industrial%20concrete%20wall%20background%20with%20subtle%20texture%2C%20editorial%20fashion%20portrait%20style&width=120&height=120&seq=avatar-james-v3&orientation=squarish',
  },
];

export default function TrustSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const prev = () => {
    setActiveIndex((prevIndex) => (prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1));
  };

  const next = () => {
    setActiveIndex((prevIndex) => (prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1));
  };

  const t = testimonials[activeIndex];

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <p className="font-display text-2xl md:text-3xl text-foreground-400 italic mb-10">
          ( Trusted by Shoppers Worldwide )
        </p>

        <div className="relative">
          <div className="flex flex-col items-center">
            <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-foreground-950 text-white mb-8">
              <i className="ri-star-fill text-amber-400 text-sm"></i>
              <span className="text-sm font-semibold">4.9</span>
            </div>

            <blockquote className="font-display text-xl md:text-2xl text-foreground-700 italic leading-relaxed max-w-2xl mb-8">
              &ldquo;{t.quote}&rdquo;
            </blockquote>

            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-background-200 overflow-hidden">
                <img
                  src={t.imageUrl}
                  alt={t.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="text-left">
                <p className="text-foreground-950 font-semibold text-sm">{t.name}</p>
                <p className="text-foreground-500 text-xs">{t.role}</p>
              </div>
            </div>
          </div>

          <div className="flex justify-center gap-3 mt-10">
            <button
              onClick={prev}
              className="w-10 h-10 rounded-lg border-2 border-background-200 flex items-center justify-center text-foreground-600 hover:border-foreground-400 transition-all cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={next}
              className="w-10 h-10 rounded-lg bg-foreground-950 text-white flex items-center justify-center hover:bg-foreground-800 transition-all cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setActiveIndex(i)}
              className={
                'w-2 h-2 rounded-full transition-all cursor-pointer ' +
                (i === activeIndex ? 'bg-foreground-950 w-6' : 'bg-background-300')
              }
            />
          ))}
        </div>
      </div>
    </section>
  );
}